import React, { createContext, useContext, useEffect, useState } from "react";
import { loadConfig, getConfig } from "../config/config";

interface ConfigContextValue {
  config: any; // Replace `any` with your actual config type
  isLoading: boolean;
  error: Error | null;
}

const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

export const ConfigProvider: React.FC = ({ children }) => {
  const [config, setConfig] = useState<any>(null);
  // Starts TRUE: MainApp's spinner branch shows while the config loads
  // (and retries) instead of rendering the app around a null config.
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  function formatAppId(appId: string): string {
    return appId
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await loadConfig();
        const loadedConfig = getConfig();
        console.log("loaded config: ", loadedConfig)
        setConfig(loadedConfig);
        setIsLoading(false);
        document.title = loadedConfig?.properties?.name || formatAppId(loadedConfig?.properties?.appId || "");
      } catch (err) {
        console.error("Failed to load configuration:", err);
        setError(err as Error);
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, isLoading, error }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
